<template>
  <aside class="bg-white w-96 flex flex-col justify-between border-r border-gray-200">
<!--    <BlocksFilter v-model="packageFilter" class="shrink-0"/>-->

    <div  class="relative grow z-10 flex">
      <ul v-if="!ready" class="grow divide-y divide-gray-200" role="list">
        <BlocksContainer :loading="true" role='navbar'/>
        <BlocksContainer :loading="true" role='landing page blocks'/>
        <BlocksContainer :loading="true" role='footer'/>

      </ul>
      <div v-else class="flex justify-between flex-col grow">
        <ul class="divide-y divide-gray-200 disable-ske" role="list">
          <BlocksContainer v-for="(role, index) in containers"
                           :role='role'
                           :packageFilter="packageFilter"
                           :key="index"
          />
        </ul>
      </div>
    </div>

  </aside>
</template>

<script>

import BlocksContainer from './BlocksContainer/BlocksContainer.vue'
import BlocksFilter from "./BlocksFilter.vue"

import { mapGetters } from 'vuex'

export default {
  components: {
    BlocksContainer,
    BlocksFilter,
  },
  data() {
    return {
      packageFilter: null,
    }
  },
  computed: {
    ...mapGetters({
      containers: 'editor/containers',
      ready: 'editor/ready',
      link: 'editor/fullDomainLink',
      config: 'editor/config',
    }),
  },
}

</script>
